document.addEventListener("DOMContentLoaded", function () {

  jQuery('.search.menu-item a, a.mobile-search').featherlight({
    targetAttr: 'href',
    variant: 'search-featherlight', 
  });
  
  var menuItems = document.querySelectorAll('#menu-main-menu > li.menu-item-has-children');
  Array.prototype.forEach.call(menuItems, function(el, i){
    var activatingA = el.querySelector('a');
    var btn = '<button> &caron; <span class="visuallyhidden">show submenu for “' + activatingA.text + '”</span></button>';
    activatingA.insertAdjacentHTML('afterend', btn);
    activatingA.setAttribute('aria-expanded', "false");
    el.querySelector('button').setAttribute('aria-expanded', "false");
  
    el.querySelector('button').addEventListener("click",  function(event){
      if (this.parentNode.classList.contains('menu-item-has-children')) {
        this.parentNode.classList.toggle('open');
      }
      if (this.parentNode.classList.contains('open')) {
        this.parentNode.querySelector('a').setAttribute('aria-expanded', "true");
        this.parentNode.querySelector('button').setAttribute('aria-expanded', "true");
      } else {
        this.parentNode.querySelector('a').setAttribute('aria-expanded', "false");
        this.parentNode.querySelector('button').setAttribute('aria-expanded', "false");
      }
      event.preventDefault();
    });
  });

  document.querySelectorAll('a.card').forEach(item => {
    item.addEventListener('click', (e) => {
          e.preventDefault();
          item.classList.toggle('flip');
    })
  })

  // Run functions on page load
  createSVG();

  // Run function on window resize -- essential so that carousel arrows rerender on viewport size change
  window.addEventListener('resize', function (event) {
    createSVG();
  });

  //create accordion
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        this.classList.toggle("active");

        /* Toggle between hiding and showing the active panel */
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }

/*
 * Replace all SVG images with inline SVG
 */

  function createSVG() {
    jQuery('img.svg').each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }

        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);

      }, 'xml');
    });
  }
});
